import { render } from "./UiVideo.vue?vue&type=template&id=52175f91"
import script from "./UiVideo.vue?vue&type=script&lang=js"
export * from "./UiVideo.vue?vue&type=script&lang=js"

import "./UiVideo.vue?vue&type=style&index=0&id=52175f91&lang=scss"
import "./UiVideo.vue?vue&type=style&index=1&id=52175f91&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__